import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { AppContextSelector } from "../app-context/app-context.selector";
import { CoreState } from "../state";

import { ACTION_PREFIX } from "./currency.action";
import { Currency, CurrencyState } from "./currency.model";
import { CurrencyService } from "./currency.service";

/**
 * @deprecated -[fabric-deprecated] - Use currency-service from app-wallet instead.
 * */
@Injectable({
	providedIn: "root",
})
export class CurrencySelector {
	constructor(private service: CurrencyService) {}

	getState() {
		return (state: CoreState): CurrencyState => state.currency;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppCommand.GetAllCurrencies instead
	 */
	getAll() {
		return (state: CoreState): Currency[] | undefined => state.currency.currencies;
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCurrentCustomer instead
	 */
	getByCurrentCustomer() {
		return (state: CoreState): Currency | undefined =>
			state.currency.currencies &&
			state.customer.customer &&
			this.service.getByCode(state.currency.currencies, state.customer.customer.basicInformation.currencyCode);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCurrentCountry instead
	 */
	getByCurrentCountry() {
		return (state: CoreState): Currency | undefined =>
			state.currency.currencies &&
			this.service.getByCountryCode(state.currency.currencies, AppContextSelector.getCountryCode(state)!);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCurrentMarket instead
	 */
	getByCurrentMarket() {
		return (state: CoreState): Currency | undefined =>
			state.currency.currencies &&
			this.service.getByCode(state.currency.currencies, state.market.currentMarket.currency);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrentCurrency instead.
	 * Although it returns currency instead of code
	 */
	getCurrent() {
		return (state: CoreState): Currency | undefined =>
			this.getByCurrentCustomer()(state) || this.getByCurrentCountry()(state) || this.getByCurrentMarket()(state);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCurrencyCode instead
	 */
	getByCode(currencyCode: string) {
		return (state: CoreState): Currency | undefined =>
			state.currency.currencies && this.service.getByCode(state.currency.currencies, currencyCode);
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCountryCode instead
	 */
	getByCountryCode(countryCode: string) {
		return (state: CoreState): Currency | undefined =>
			state.currency.currencies && this.service.getByCountryCode(state.currency.currencies, countryCode);
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use WalletAppValue.CurrencyByCountryCodes instead
	 */
	getByCountryCodes(countryCodes: string[]) {
		return (state: CoreState): Currency[] | undefined =>
			state.currency.currencies && this.service.getByCountryCodes(state.currency.currencies, countryCodes);
	}

	isBusy() {
		return (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
